export type AdminReportsResponse = {
  summary: {
    paidRevenueTotal: number;
    paidOrdersTotal: number;
    currentMonthRevenue: number;
    currentMonthPaidOrders: number;
    unpaidOrdersTotal: number;
    outstandingBalanceTotal: number;
    discountsTotal: number;
    customerCount: number;
  };
  monthlySeries: Array<{
    monthKey: string;
    monthLabel: string;
    paidRevenue: number;
    paidOrders: number;
  }>;
  dailySeries: Array<{
    dayKey: string;
    dayLabel: string;
    paidRevenue: number;
    paidOrders: number;
  }>;
  topProducts: Array<{
    inventoryId: number | null;
    name: string;
    slug: string | null;
    category: string;
    unitsSold: number;
    paidRevenue: number;
    paidOrders: number;
  }>;
  categoryPerformance: Array<{
    category: string;
    unitsSold: number;
    paidRevenue: number;
    paidOrders: number;
  }>;
  couponPerformance: Array<{
    couponId: number | null;
    code: string;
    description: string;
    usesTotal: number;
    paidRevenue: number;
    discountTotal: number;
  }>;
  paymentMix: Array<{
    paymentType: string;
    ordersTotal: number;
    paidRevenue: number;
  }>;
};

async function parseResponse(response: Response) {
  const data = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(data?.message || `Request failed: ${response.status}`);
  }

  return data;
}

export async function fetchAdminReports() {
  const response = await fetch("/api/admin/reports", {
    credentials: "include",
    headers: {
      Accept: "application/json"
    }
  });

  return (await parseResponse(response)) as AdminReportsResponse;
}
